import type { StatusTone } from '../../../design-system';
import type { StaffingPlan, StaffingPlanInput } from '../operations/planModel';

export function staffingPlanDisplayStatus(plan: StaffingPlan, today = new Intl.DateTimeFormat('sv-SE', { timeZone: 'Asia/Seoul' }).format(new Date())) {
  return plan.status === 'COMPLETED' && plan.effectiveDate > today ? 'AWAITING_EFFECTIVE' : plan.status;
}
export function staffingPlanStatus(plan: StaffingPlan): { label: string; tone: StatusTone } {
  switch (staffingPlanDisplayStatus(plan)) {
    case 'DRAFT': return { label: '초안', tone: 'warning' };
    case 'SUBMITTED': return { label: '승인 중', tone: 'info' };
    case 'AWAITING_EFFECTIVE': return { label: '시행 대기', tone: 'info' };
    case 'COMPLETED': return { label: '완료', tone: 'success' };
    case 'DENIED': return { label: '반려', tone: 'danger' };
    default: return { label: '취소', tone: 'neutral' };
  }
}
export function staffingPlanMatches(plan: StaffingPlan, query: string) {
  const text = [plan.title, plan.reason, ...plan.organizationChanges.flatMap(row => [row.name, row.organizationDescriptor]), ...plan.workerChanges.map(row => row.workerDescriptor)].filter(Boolean).join(' ').toLocaleLowerCase('ko');
  return text.includes(query.trim().toLocaleLowerCase('ko'));
}
export function staffingPlanTargetSummary(plan: StaffingPlan) {
  const people = plan.workerChanges.map(row => row.workerDescriptor).filter(Boolean);
  const organizations = plan.organizationChanges.map(row => row.name || row.organizationDescriptor).filter(Boolean);
  return [people.length ? `${people[0]}${plan.workerChanges.length > 1 ? ` 외 ${plan.workerChanges.length - 1}명` : ''}` : plan.workerChanges.length ? `구성원 ${plan.workerChanges.length}명` : '',
    organizations.length ? `${organizations[0]}${plan.organizationChanges.length > 1 ? ` 외 ${plan.organizationChanges.length - 1}개 조직` : ''}` : plan.organizationChanges.length ? `조직 ${plan.organizationChanges.length}개` : ''].filter(Boolean).join(' · ');
}
/** 원 요청의 결재·버전 정보는 복사하지 않고 입력과 신설 조직 참조만 유지합니다. */
export function copyStaffingPlanInput(plan: StaffingPlan): StaffingPlanInput {
  return structuredClone({ title: `${plan.title.slice(0, 190)} (사본)`, effectiveDate: plan.effectiveDate, reason: plan.reason,
    organizationChanges: plan.organizationChanges, workerChanges: plan.workerChanges });
}
